import { IChapter, ICourse, ISubchapterTeaser } from "models/course";

export const getChapter = (course?: ICourse, subchapterId?: string): IChapter | undefined =>
  course?.chapters?.find((c) => c.subchapters.some((s) => s.id === subchapterId));

export const getSubchapterTeaser = (chapter?: IChapter, subchapterId?: string): ISubchapterTeaser | undefined =>
  chapter?.subchapters.find((s) => s.id === subchapterId);
